import { isEmpty } from "lodash";

export const getStrippedHtml = (html: string) => {
    return isEmpty(html) ? "" : new DOMParser().parseFromString(html, "text/html").body.textContent;
};
